import { useMemo } from "react";
import { AssessmentStatus } from "../../../../../utils/enums";

export const useAssessmentPermissions = (currentSystem, currentUserEmail, currentAssessment) => {
  const userIsOwner = useMemo(() => {
    if (!currentSystem?.system_admin || !currentUserEmail) return false;
    return currentSystem.system_admin.toLowerCase().trim() === currentUserEmail.trim();
  }, [currentSystem, currentUserEmail]);

  const isCompletedOrRejected = useMemo(() => {
    return currentAssessment?.status_title?.toLowerCase() === AssessmentStatus.COMPLETED || 
           currentAssessment?.status_title?.toLowerCase() === AssessmentStatus.REJECTED;
  }, [currentAssessment]);

  const isSystemArchived = !currentSystem?.is_review_active;
  const isDraftAndNotOwner = currentAssessment?.status_title?.toLowerCase() === AssessmentStatus.DRAFT && !userIsOwner;
  const shouldDisableActions = isDraftAndNotOwner || isSystemArchived;

  return {
    userIsOwner,
    isCompletedOrRejected,
    isSystemArchived,
    isDraftAndNotOwner,
    shouldDisableActions,
  };
};

